import type { ComponentType } from "react";

export function HeroIllustration({
  illustration: Illustration,
  label,
}: {
  illustration: ComponentType<React.SVGProps<SVGSVGElement>>;
  label: string;
}) {
  return (
    <div className="relative mx-auto hidden aspect-square w-full max-w-md lg:block">
      <Illustration role="img" aria-label={label} className="h-full w-full object-contain" />
    </div>
  );
}
